import { registryApi } from '../clients/AxiosClients'

/**
 * Retorna todas as categorias de arvores cadastradas no banco de dados
 */
const getAllCategoriaDeArvore = async () => {
	return registryApi.get('v1/CategoriaArvore')
}

/**
 * Cadastrar nova categoria de arvore no banco de dados
 * @param {Object} body Categoria de arvore que será cadastrada
 */
const createCategoriaDeArvore = async (body) => {
	return registryApi.post('v1/CategoriaArvore/CreateCategoriaArvore', body)
}

/**
 * Atualiza categoria de arvore no banco de dados
 * @param {Object} body Categoria de Arvore que será atualizada
 */
const updateCategoriaDeArvore = async (body) => {
	return registryApi.put('v1/CategoriaArvore/UpdateCategoriaArvore', body)
}

/**
 * Lista dos ids de categorias de arvore que devem ser excluidos do banco de dados
 * @param {Array} body Lista dos ids de categoria de arvores
 */
const deleteCategoriaDeArvoreByIdList = async (data) => {
	return registryApi.delete('v1/CategoriaArvore/DeleteByIdList', { data })
}

export {
	getAllCategoriaDeArvore,
	createCategoriaDeArvore,
	updateCategoriaDeArvore,
	deleteCategoriaDeArvoreByIdList,
}
